import { testimonials } from '@/mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            来访者心声
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            每一位来访者的信任和改变，都是我们前进的最大动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="p-6 rounded-xl bg-background-50 border border-background-200/50"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                「{t.content}」
              </p>
              <div className="pt-3 border-t border-background-200/50">
                <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                <p className="text-xs text-foreground-500 mt-1">{t.service}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}